import React from "react";
export function usePageLoaded() {
  const [loaded, setLoaded] = React.useState(false);
  React.useEffect(() => {
    if (document.readyState === "complete") {
      setLoaded(true);
      return;
    }
    const handler = () => setLoaded(true);
    window.addEventListener("load", handler, {
      once: true
    });
    return () => window.removeEventListener("load", handler);
  }, []);
  return loaded;
}